// Import model
import { DataviewContactResponse } from '../models/DataviewContactResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { Contact } from '../models/Contact';
import { DataView } from '../models/DataView';
import { FilterContactRequest } from '../models/FilterContactRequest';

// Import dependency serializers (for complex types)
import { ContactSerializer } from './ContactSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterContactRequestSerializer } from './FilterContactRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewContactResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewContactResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewContactResponse instance
   */
  static deserialize(json: string): DataviewContactResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewContactResponse instance
   */
  static fromObject(obj: any): DataviewContactResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewContactResponse');
    }


    const instance: DataviewContactResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ContactSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterContactRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewContactResponse instances
   */
  static deserializeArray(json: string): DataviewContactResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewContactResponse instance to a JSON string
   */
  static serialize(instance: DataviewContactResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewContactResponse instance to a plain object
   */
  static toObject(instance: DataviewContactResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ContactSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterContactRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewContactResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewContactResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
